module.exports = "<app-page-header title=\"Dashboard\" icon=\"dashboard\"></app-page-header>\r\n<div class=\"page-content\">\r\n\r\n    \r\n</div>\r\n"